import { icons, note, nav } from "./components/html";

export default `
${nav([
  { text: "Introduction", link: "#introduction" },
  { text: "Basics work with API", link: "#basics" },
  { text: "Division of end points", link: "#division" },
  { text: "Authentication", link: "#authentication" },
  { text: "Overview of endpoints", link: "#schemes" }
])}

<div id="introduction"> </div>

## Introduction

SizeID Business API is **JSON** application interface based on **REST** principles that provide clients application and especially e-shops access to SizeID  for business services. Offers many options to improve the user's shopping experience as well as business results.
  
Access to API i protected by authentication - ie. access verification  is required using your account information. The use of the API ise charged according to the Tariff Price List and is automatically invoiced through the SizeId for Business client interface. 

Requests working with specific user account also require user authentication using the user's access data, which must be implemented on the e-shop side.

<div id="basics"> </div>

## Basic work with API

SizeID Business API is based on REST principles - data sources are accessible via standard HTTPS requests in UTF-8 format, sent to specific endpoint of server URL according to the request    

For each request is necessary to use correct type based on the action that the request is mediating.

|Type  | Description |
|---|---|
|GET            | Use for sourcing resources |
|POST           | Use for creating new resources |
|PUT            | Use for change or replace resources or collections |
|DELETE         | Use for deleting resources | 

### Response structure

All response bodies are in JSON format and have following structure. Response structure of authentication server follow [RFC 6749](https://tools.ietf.org/html/rfc6749).

**Response based on successful processing of request (status code 2xx)**<br><br>
**Response based on unsuccessful processing of request (status code 4xx)**

### Endpoint call error messages

If the request is not successful, the object with the error information is returned. It always has the following attributes:

|Parameter|	Date type| Description|	Example|
|---|---|---|---|
|status	    | integer           |	HTTP status code                                                                        | 422|
|code       |	integer	          | Sizeid error code - returned as well in head as SizeID-Error-Code                       | 3|
|parameters | array of objects  |	List of the required parameter that are necessary to successfully process the request. | {"size_chart_id": 1415, ...}|
|message    |	string            |	Short explanation of the error.                                                         |	"Size chart '510' not added by client."|

### Overview of SizeID error codes


Error code|Description
---|---
0| No explanatory message. The error state is sufficiently specified by the standard HTTP response code.
1| The size chart is not among the active client tables.
2| The size chart has already been added to the active client tables.
3| The request lacks some parameters that are necessary for its successful processing.
4| The Measures sent as parameters in the request header are outside the values allowed for the measures.
5| The client does not have activated "Extended" Business Api features that are necessary to successfully execute the request.
6| The limit set by the selected tariff has been exceeded.
7| The client is not allowed to access this section.
8| The user is not allowed to access this section.
9| Active size charts allowed limit exceeded.
10|	Exceeded limit of allowed size charts operations (repeated adding and removing). Upgrade or wait for the next billing period.

<div id="localization"></div>

### Localization
All requests accept the **Accept-Language** parameter in the head according to [RFC 7231](https://tools.ietf.org/html/rfc7231), which specifies the language of the response. 

Each response carries a **Content-Language** parameter in the head, which specifies the language in which the data is sent within the response.

If the **Accept-Language** parameter requires a language that is not supported or is not availabel for the data at the moment, the response language is automatically set to the default language (Czech).

### Limitations of number of requests
The number of API requests sent from one SizeID for Business business account is limited by the tariff (if no overdraft is applied) as well as by security mechanisms that prevent unintentional or unauthorized resource overload. This protects the SizeID for Business business account primarily from unauthorized use of its resources.

To implement the features using the SizeID Business API, we recommend making maximum use of bulk calls and thus generally reducing the amount of requests. In general, we recommend paying close attention to how to implement and use the SizeID Business API, taking into account the frequency and type of requests, both in terms of response speed and cost. If you need help with your SizeID Business API implementation, please contact us.

<div id="division"> </div>

## Division of end points


Endpoints addresses are divided according to the logic of the endpoint usage area.

Adresa | Popis
---|---
/...| General database and SizeId requests. E.g. search for size chart in the SizeID database.
/client/...| Requests related to SizeID for Business trading account. E.g. for working with active size charts.
/visitor/...| Requests that can be applied to a visitor who is not SizeId user or should not require SizeId user authorization. The visitor is identified either by e-mail or by Cros Web ID. These endpoints can be used, for example, to determine the appropriate visitor size according to a certain size table.
/user/...	| Requests that apply to a specific SizeID user. These endpoints can be used, for example, for detailed size recommendations or for working with a SizeID user account.

Endpoints are marked with the following properties or limitations:

Icon|Description|Requirements
---|---|---
${
  icons.c
}|**Requires SizeID for Business login**| You must have a valid administration access token to use..
${
  icons.u
}|**Requires SizeID user login**| You must have a valid user account access token to use.
${
  icons.e
}|**Only for SizeID for Business Extended**| You must have an extended version of your SizeID for Business account to use it. Contact us for more information.

<div id="authentication"> </div>

## Authentication and authorization
All API requests require authentication and pairing with a SizeID for Business account. SizeID Business API uses OAuth 2.0 authorization framework according to [RFC 6749](https://tools.ietf.org/html/rfc6749)

${note(
  `For communication with SizeID API you can use package [sizeid/oauth2](https://github.com/sizeid/oauth2).`
)}

Supported types||Description
---|---|---
Authorization Code Grant|[RFC 6749 4.1](https://tools.ietf.org/html/rfc6749)| Provides access token and refresh token for endpoints marked with ${
  icons.u
}. Suitable for long-term user login - possibility to renew the token validity.
Client Credentials Grant|	[RFC 6749 4.4](https://tools.ietf.org/html/rfc6749)|	Provides access token token for endpoints marked with ${
  icons.c
} Suitable for administration activities over SizeId for Business account.
Implicit Grant|	[RFC 6749 4.2](https://tools.ietf.org/html/rfc6749)|	Provides access token and refresh token for endpoints marked with ${
  icons.u
}Suitable for user login form single page application. You do not need the API Secure Key to log in.

<div id="schemes"></div>

## Overview of endpoints
${note(
  'You can try almost each endpoint by clicking on `Try it out` button. Keep in mind that for most endpoints you need to have token. You can add tokens (for testing) by clicking on the lock icon or on `Authorize" button`. Or you can use our [demo](http://demo.sizeid.com/) where you do not need any access tokens'
)}
`;
